module.exports = __webpack_public_path__ + "img/postprocessing.e785b042.svg";